/** OVIN — Ontario Vehicle Innovation Network (formerly OCE automotive). */
export const OVIN_TASKS = [
  {
    id: 1,
    name: "Program fit",
    completed: false,
    subtasks: [
      { id: "1-1", name: "Match project to OVIN stream (R&D, talent, demonstration)", completed: false },
      { id: "1-2", name: "Confirm Ontario operations and automotive/mobility focus", completed: false },
    ],
  },
  {
    id: 2,
    name: "Application",
    completed: false,
    subtasks: [
      { id: "2-1", name: "Draft project plan with industry partner if required", completed: false },
      { id: "2-2", name: "Submit via OVIN portal before deadline", completed: false },
    ],
  },
  {
    id: 3,
    name: "Project delivery",
    completed: false,
    subtasks: [
      { id: "3-1", name: "Meet reporting and matching fund requirements", completed: false },
      { id: "3-2", name: "Submit claims for reimbursement", completed: false },
    ],
  },
];

/** NOHFC — Northern Ontario Heritage Fund Corporation. */
export const NOHFC_TASKS = [
  {
    id: 1,
    name: "Northern Ontario eligibility",
    completed: false,
    subtasks: [
      { id: "1-1", name: "Confirm project location in NOHFC catchment area", completed: false },
      { id: "1-2", name: "Select fund stream (business, innovation, hiring, etc.)", completed: false },
    ],
  },
  {
    id: 2,
    name: "Application package",
    completed: false,
    subtasks: [
      { id: "2-1", name: "Prepare business case and economic impact narrative", completed: false },
      { id: "2-2", name: "Submit application with budget and timelines", completed: false },
    ],
  },
  {
    id: 3,
    name: "Approval & compliance",
    completed: false,
    subtasks: [
      { id: "3-1", name: "Execute funding agreement", completed: false },
      { id: "3-2", name: "File progress reports and final claim", completed: false },
    ],
  },
];

/** Alberta Innovates — provincial innovation funding. */
export const ALBERTA_INNOVATES_TASKS = [
  {
    id: 1,
    name: "Program selection",
    completed: false,
    subtasks: [
      { id: "1-1", name: "Match to Alberta Innovates program (R&D, Voucher, etc.)", completed: false },
      { id: "1-2", name: "Confirm Alberta entity and project alignment", completed: false },
    ],
  },
  {
    id: 2,
    name: "Proposal",
    completed: false,
    subtasks: [
      { id: "2-1", name: "Draft technical and commercialization sections", completed: false },
      { id: "2-2", name: "Submit via Alberta Innovates portal", completed: false },
    ],
  },
  {
    id: 3,
    name: "Award management",
    completed: false,
    subtasks: [
      { id: "3-1", name: "Fulfill reporting and matching requirements", completed: false },
      { id: "3-2", name: "Close project with final report", completed: false },
    ],
  },
];
